import {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {clientBillingCardAPI} from "../../../services/client";
//정기결제 카드 등록 성공 페이지
export const ClientBillingRegisterPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(true);

    useEffect(() => {
        const processPayment = async () => {
            try {
                //카드 인증 성공 시 반환 받는 값, 정기결제에 필요
                const authKey = searchParams.get('authKey');

                if (!authKey) {
                    throw new Error('필수 결제 정보가 누락되었습니다.');
                }
                //authKey 저장 API
                await clientBillingCardAPI(authKey);
                //결제 페이지로 이동
                navigate('/client/billing');
            } catch (error) {
                console.error('결제 처리 중 오류 발생:', error);
                // 에러 발생 시 에러 페이지나 이전 페이지로 이동
                navigate('/payment/fail', {
                    replace: true,
                    state: {error: '결제 처리 중 오류가 발생했습니다.'}
                });
            } finally {
                setIsProcessing(false);
            }
        };

        processPayment();
    }, [navigate, searchParams]);

    if (isProcessing) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <h2 className="text-xl font-semibold mb-2">결제 처리 중...</h2>
                    <p className="text-gray-600">잠시만 기다려주세요.</p>
                </div>
            </div>
        );
    }

    return null;
};

export default ClientBillingRegisterPage;